import { pickT } from "@repo/shared";
import { T } from "./user-display.i18n";

type NamedUser = { name: string | null; deletedAt?: string | null };

/** The user's name, suffixed with "(deleted)" in the viewer's language when deleted. */
export function displayUserName(
  user: NamedUser | null | undefined,
  language: string,
): string | null {
  if (!user?.name) return null;
  if (!user.deletedAt) return user.name;
  return `${user.name} ${pickT(T, language).deleted}`;
}
